module.exports = __webpack_public_path__ + "img/9788983947666.3cd234ae.jpg";